import styled from 'styled-components';

export default styled.div`
  width: 580px;
  height: 330px;
  margin: 20px auto 0;
  position: relative;
`;
